import type { ProtocolMetadata } from "@/types";
import useApi from "@/hooks/api/useApi";

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-4d123e45-c1f4-4dd3-914e-c6d7591f5bd9?ctx=documentation
 */
export default function useProtocol(protocolId: string | undefined, blockLoading: boolean = false) {
  const { data, isLoading, isError, mutate } = useApi<ProtocolMetadata, ProtocolMetadata>(
    {
      path: `/protocol/?vanity_url=${protocolId}`,
      api: "v2",
    },
    {
      enabled: !blockLoading && !!protocolId,
      strategy: "on-mount",
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
